import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Adal8Service } from 'adal-angular8';
import { interval } from 'rxjs';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { Login } from '../../../observation/model/login.model';
import { ObservationService } from '../../../observation/services/observation.service';
import { AuthenticationService } from '../../services/authentication.service';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../services/common.service';
import { ConstantsService } from './../../services/constants.service';
import { GlobalConstants } from '../../services/GlobalConstants.service';
//import { HomeComponent } from '../home/home.component';

@Component({
  selector: 'ara-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  logoSrc =GlobalConstants.SiteLogoPath;

  // isUserLoggedIn = false;
  // loggedInUser: any;
  // isLoginPage = false;
  // loggedinUserType: string = "";
  // permissions: any = [];
  // isOnline: boolean = false;

  // constructor( public baseService: BaseService,) { }

  // ngOnInit(): void {
  //   this.checkOnlineStatus();
  //   const loggedInUser = this.baseService.getItemFromSession(
  //     ConstantsService.commonConstants.loggedInUser
  //   );
  //   this.loggedInUser = JSON.parse(loggedInUser);
  //   let redirectUri;
  //   if (window.location.href === ConstantsService.URL.APP) {
  //     this.isLoginPage = true;
  //     redirectUri = ConstantsService.URL.APP + ConstantsService.URL.HOMEPAGE;
  //   } else {
  //     redirectUri = ConstantsService.URL.APP;
  //   }
  //   this.loggedinUserType = this.baseService.getItemFromSession(
  //     ConstantsService.LoggedInUserType
  //   );

  //   if (loggedInUser) {
  //     this.isUserLoggedIn = true;
  //     const permissionsFromSession = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
  //     if (permissionsFromSession) {
  //       this.permissions = permissionsFromSession;
  //     }
  //   }
  //   else 
  //   this.isUserLoggedIn = false;
  // }

  // checkOnlineStatus() {
  //   const repeatCheck = interval(1000);
  //   repeatCheck.subscribe(val => {
  //     if (navigator.onLine) {
  //       this.isOnline = true;
  //     }
  //     else {
  //       this.isOnline = false;
  //     }
  //   });
  // }

  loggedInUserJSON: any;
  loginDate: Date = new Date();
  userloginid: number;
  IpAddress: string;
  isAppAdmin: boolean = false;
  isValidUser: boolean;
  permissions: any = [];
  isOnline: boolean = false;
  login: Login;
  units: any;
  unitsProcessed: number;
  constructor(private baseService: BaseService,
    private adal4Service: Adal8Service,
    private commonService: CommonService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private masterscreenService: MasterscreenService,
    private observationService: ObservationService) {
     
  }


  async ngOnInit() {
    this.checkOnlineStatus();
    this.authenticationService.fetchIPInfo();
    if (this.adal4Service && this.adal4Service.userInfo) {
      this.baseService.showRootLoader = false;
      this.baseService.reportRoutes = [];
      this.baseService.routesFlag = [];
      this.setUserDetails();
      await new Promise(f => setTimeout(f, 1000));
    }

    const loggedinUserType = this.baseService.getItemFromSession(ConstantsService.LoggedInUserType);
    if (loggedinUserType === ConstantsService.authenticationType.Contractor) {
      this.setUserDetails();
    }
    if (loggedinUserType === ConstantsService.authenticationType.Employee) {
      this.setUserDetails();
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
    if(this.loggedInUserJSON !== null && (typeof this.loggedInUserJSON !== 'undefined')){
    if (navigator.onLine) {
      const apiRequestUnit = {
        Model: {
          ModuleId: 4,
          UserId: this.loggedInUserJSON.UserId
        }
      }
      this.masterscreenService.getUnits(apiRequestUnit, this.callbackMethodForUnitDetails.bind(this));

    }
  }
  }
  callbackMethodForUnitDetails(response) {
    this.baseService.setItemInSession('obs_Units', JSON.stringify(response.Result));
    this.login = new Login();
    this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.login.ID = this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: {
        GetActiveNodes: true
      }
    }
    this.masterscreenService.getAllTreeData(apiRequest, this.callbackMethodForGetTreeData.bind(this));

  }
  callbackMethodForGetTreeData(response) {
    this.baseService.setItemInSession('unitTree', JSON.stringify(response.Result));
    this.unitsProcessed = 0;
    this.units = [];
    response.Result.forEach(element => {
      this.iterateTree(element);
    });
    if (this.units.length > 0) {
      this.login.UnitId = this.units[this.unitsProcessed];
      const apiRequest = {
        Model: this.login
      };
      this.observationService.getLocationData(apiRequest, this.callbackMethodForGetLocationData.bind(this));
    }
    this.observationService.getUserTypes(this.callbackMethodForgetUserTypes.bind(this));
  }
  processLocation(unitId) {
    this.login.UnitId = unitId;
    const apiRequest = {
      Model: this.login
    };
    this.observationService.getLocationData(apiRequest, this.callbackMethodForGetLocationData.bind(this));
  }
  iterateTree(node) {
    this.login.UnitId = node.UnitId;
    this.units.push(node.UnitId);
    if (node.children && node.children.length > 0) {
      node.children.forEach(element => {
        if (element.children && element.children.length > 0) {
          this.iterateTree(element);
        }
      });
    }
  }
  callbackMethodForGetLocationData(response) {
    if (response && response.Result) {
      this.baseService.setItemInSession('locations_' + this.units[this.unitsProcessed], JSON.stringify(response.Result));
    }
    this.unitsProcessed++;
    if (this.unitsProcessed < this.units.length) {
      this.processLocation(this.units[this.unitsProcessed]);
    }
  }
  callbackMethodForgetUserTypes(response) {
    this.baseService.setItemInSession('userTypes', JSON.stringify(response.Result));
    this.masterscreenService.getAllModules(null, this.callbackMethodForGetAllModules.bind(this));
    const apiRequest = {
      Model: {
        CompanyId: 1
      }
    };
    this.observationService.getHazardTypeByCompanyId(apiRequest, this.callbackMethodForGetHazardTypeDetails.bind(this));
  }
  callbackMethodForGetAllModules(response) {
    this.baseService.setItemInSession('modules', JSON.stringify(response.Result));
  }
  callbackMethodForGetHazardTypeDetails(response) {
    this.baseService.setItemInSession('hazards', JSON.stringify(response.Result));
    const apiRequest1 = {
      Model: this.login
    };
    this.observationService.getCompanyData(apiRequest1, this.callbackMethodForgetCompanyData.bind(this));
  }
  callbackMethodForgetCompanyData(response) {
    this.baseService.setItemInSession("company", JSON.stringify(response.Result));
    const apiRequest2 = {
      Model: {
        'companyId': this.loggedInUserJSON.Company.CompanyId
      }
    };
    this.observationService.getObservationTypeByCompanyId(apiRequest2, this.callbackMethodForGetObservationTypeDetails.bind(this));
  }
  callbackMethodForGetObservationTypeDetails(response) {
    this.baseService.setItemInSession("obsTypes", JSON.stringify(response.Result));
    this.observationService.getProcess(this.callbackMethodForgetProcess.bind(this));
  }
  callbackMethodForgetProcess(response) {
    const processList = response.Result;
    this.baseService.setItemInSession("processList", JSON.stringify(response.Result));
    processList.forEach(process => {
      if (process.ProcessName === 'Observation') {
        this.getStatusByProcessId(process.ProcessId);
      }
    });
  }
  getStatusByProcessId(processId) {
    const apiRequest = {
      Model: {
        ProcessId: processId
      }
    };
    this.observationService.getStatusByProcessId(apiRequest, this.callbackMethodForgetStatus.bind(this));
  }
  callbackMethodForgetStatus(response) {
    this.baseService.setItemInSession("obsStatus", JSON.stringify(response.Result));
    const login = new Login();
    login.CompanyId = 0;
    const apiRequest = {
      Model: login
    };
    this.observationService.getLocationData(apiRequest, this.callbackMethodForAllLocationData.bind(this));
  }
  callbackMethodForAllLocationData(response) {
    this.baseService.setItemInSession("allLocations", JSON.stringify(response.Result));
  }
  checkOnlineStatus() {
    const repeatCheck = interval(1000);
    repeatCheck.subscribe(val => {
      if (navigator.onLine) {
        this.isOnline = true;
      }
      else {
        this.isOnline = false;
      }
    
    });
    
  }
  setUserDetails() {
    const loggedInUser = this.baseService.getItemFromSession(ConstantsService.commonConstants.loggedInUser);
    if(loggedInUser !== null) {
    this.loggedInUserJSON = JSON.parse(loggedInUser);

    if (this.loggedInUserJSON.UserId) {
      this.isValidUser = true;
      this.commonService.getUserIndependentPermissions(this.loggedInUserJSON.UserId);
      let UserLogInInformationId = this.baseService.getItemFromSession('UserLogInInformationId');
      const savedIP = this.baseService.getItemFromSession('ipAddress');
      this.IpAddress = savedIP;

      if (UserLogInInformationId === null) {
        this.userloginid = 0;
      } else {
        this.userloginid = parseInt(UserLogInInformationId);
      }

      if (this.loggedInUserJSON !== null && UserLogInInformationId === null) {
        this.commonService.saveUserLogInInfo(this.loginDate, null, this.loggedInUserJSON.UserId, this.userloginid, this.IpAddress)
      }
      const permissionsFromSession = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
      if (permissionsFromSession) {
        this.permissions = permissionsFromSession;
      }
    } else {
      this.loggedInUserJSON = null;
      this.isValidUser = false;
    }
  }
  else {
    this.isValidUser = false;
  }
    this.baseService.setItemInSession('observationIds', null);
    this.baseService.setItemInSession('incidentIds', null);
    this.baseService.setItemInSession('riskIds', null);
    this.baseService.setItemInSession('actionIds', null);
    this.baseService.setItemInSession('pobRequests', null);
    this.baseService.setItemInSession('passRequests', null);
    this.baseService.setItemInSession('inspectionIds', null);
    this.baseService.setItemInSession('taskIds', null);
    this.baseService.setItemInSession('PTWIds', null);
    this.baseService.setItemInSession('TnCIds', null);
    this.baseService.setItemInSession('StatisticIds', null);
    this.baseService.setItemInSession('riskIds',null);
  }

}
